import { useNavigate, useLocation } from 'react-router-dom';

export function useCrossSellHistory() {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    push: (path, state) => navigate(`/cross-sell${path}`, { state }),
    replace: (path, state) =>
      navigate(`/cross-sell${path}`, { replace: true, state }),
    location,
    back: () => navigate(-1),
    forward: () => navigate(1),
  };
}
